import { render, staticRenderFns } from "./PickUpRequests.vue?vue&type=template&id=bb63fe2c&lang=pug"
import script from "./PickUpRequests.vue?vue&type=script&lang=js"
export * from "./PickUpRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports